import React from 'react';
import { AppGridLayout, AppTableSearch, AppTable, AppRow, AppButton } from 'qcc';
import { AppAction, AppGridBar, AppFilter } from 'qcc';
import api, { PosMerchant } from "api";
import EditForm from "./DeviceAdd";
import { Icon } from 'antd';

const getFilter = (posMerchantId?: number) => {
  return [{
    keyName: 'posMerchantId',
    lable: '',
    field: 'pos_merchant_id',
    min: '',
    max: '',
    opr: '',
    value: `${posMerchantId}`,
    list: [],
    searchItemType: 'projectFilter'
  }] as AppFilter[]
}

export default class extends React.Component<{ posMerchantId?: number }> {
  state = {}

  add = async () => {
    let title = '新增设备';
    let width = 600;
    let height = 380;
    let editForm = <EditForm mode={1} formData={{ pos_merchant_id: this.props.posMerchantId }} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title, height, width });
  }

  delete = async (data?: any) => {
    if (await AppAction.deleteConfirm('您确定要删除该记录吗？')) {
      await api.posmerchant.removeDevice({ id: data.id });
      AppAction.successMsg('操作成功！');
      this.afterSave();
    }
  }

  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }

  refGrid = React.createRef<AppGridLayout>();

  render() {
    return (
      <AppGridLayout ref={this.refGrid} style={{ padding: 0 }}>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Left>
              <div style={{ paddingLeft: 20 }}>{'POS设备列表'}</div>
            </AppGridBar.Left>
            <AppGridBar.Right>
              <AppRow style={{ float: 'right', marginRight: 20 }}>
                <AppButton label='新增' actionCode="66201202" type='primary' action={this.add} />
              </AppRow>
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable sqlId='sql.pos.merchantDeviceGrid'
            queryDataList={getFilter(this.props.posMerchantId)}
            paging>
            <AppTable.ColIndex />
            <AppTable.Col title='POS设备SN码' field='mac' width={300} />
            <AppTable.Col title='备注' field='remarks' />
            <AppTable.ColAction width={100} render={(data: any, dataIndex: number) => {
              return (<AppRow itemSplit={10} style={{ float: 'right' }}>
                <AppButton type='link' label='移除' actionCode="66201202" action={() => this.delete(data)} />
              </AppRow>);
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/merchant/DeviceIndex.tsx